<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [class]="
    isShowAuthenticatedMobileAuditPage ||
    isShowOrganizationResellers ||
    isShowOrganizationAuthentication ||
    isShowOrganizationDocumentation ||
    isShowOrganizationTransaction ||
    isShowOrganizationTransactions ||
    isShowOrganizationGroupPriceDetail ||
    isShowOrganizationBlackListExceptions ||
    isShowUserDocumentation
      ? 'd-none'
      : ''
  "
  [config]="pageConfig"
  (onAdd)="onCreate()"
  (sortObject)="getSortItems($event)"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
  (onShowHelpPage)="onShowHelpPage()"
>
  <!--------------------------------------- Audit btns ---------------------------------------->
  <div class="card-toolbar" before-btns>
    <div class="card-toolbar" before-btns>
      <!-- excel btn -->
      <button
        [disabled]="(items$ | async)?.length == 0"
        (click)="onExcelReport()"
        class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
        type="button"
        mat-ripple
        [matTooltip]="'common.downloadExcel' | translate"
      >
        <i class="mdi mdi-download mdi-20px tw-p-0 text-info"></i>
      </button>
    </div>

    <!-- audit menu btn -->
    <a
      *ngIf="permissionService.userState()?.isSuperAdmin"
      [matMenuTriggerFor]="menu"
      class="btn btn-light txt-lg button-shadow tw-mx-1"
      type="button"
      mat-ripple
      [matTooltip]="'pages.audits.title' | translate"
    >
      <i class="mdi mdi-eye mdi-20px tw-p-0 text-info"></i>
    </a>

    <mat-menu #menu="matMenu" xPosition="after">
      <!-- group price audit -->
      <a
        mat-menu-item
        class="txt-lg button-shadow tw-flex tw-items-center border-bottom"
        mat-ripple
        (click)="onShowAuditPage()"
      >
        <span class="tw-mx-1">{{ pageVocabs + "title" | translate }}</span>
      </a>

      <!-- group price detail audit -->
      <a
        mat-menu-item
        class="txt-lg button-shadow tw-flex tw-items-center"
        mat-ripple
        (click)="onisShowAuthenticatedMobileAuditPage()"
      >
        <span class="tw-mx-1">{{
          pageVocabs + "authenticatedMobile" | translate
        }}</span>
      </a>
    </mat-menu>
  </div>

  <!--------------------------------------- Table Content --------------------------------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
        [ngClass]="currentDateTime > item.expireDate ? 'tr-expired' : ''"
      >
        <!-- index -->
        <td class="!tw-px-4 tw-text-center text-gray tw-py-4">
          <span class="tw-text-gray-700 dark:tw-text-gray-300">
            {{ paginationModel?.firstIndex + i }}</span
          >
        </td>

        <!-- name -->
        <td>
          <td-value copyToClipboard [value]="item?.name"></td-value>
        </td>

        <!-- parentName -->
        <td>
          <td-value copyToClipboard [value]="item?.parentName"></td-value>
        </td>

        <!-- domainName -->
        <!-- [copyValue]="item?.userDomainLink" -->
        <td>
          <td-value copyToClipboard [value]="item?.domainName"></td-value>
        </td>

        <!-- credit -->
        <td>
          <span
            copyToClipboard
            [class]="fontSize == 'sm' ? 'tw-text-[11px]' : 'tw-text-[12px]'"
            [credit]="item?.credit"
            >{{ item?.credit | numberSeparator | checkValue }}</span
          >
        </td>

        <!-- panelPrice -->
        <td>
          <td-value
            copyToClipboard
            type="number"
            [value]="item?.panelPrice"
          ></td-value>
        </td>

        <!-- groupPriceCategoryTitle  -->
        <td class="tw-dir-rtl">
          <td-value
            copyToClipboard
            type="text"
            [value]="item?.groupPriceCategoryTitle"
          ></td-value>
        </td>

        <!-- isActive -->
        <td>
          <td-value type="boolean" [value]="item?.isActive"></td-value>
        </td>

        <!-- isActiveSend -->
        <td>
          <td-value type="boolean" [value]="item?.isActiveSend"></td-value>
        </td>

        <!-- isAuthenticated -->
        <td>
          <td-value type="boolean" [value]="item?.isAuthenticated"></td-value>
        </td>

        <!-- isPostpaid -->
        <td>
          <td-value type="boolean" [value]="item?.isPostpaid"></td-value>
        </td>

        <!-- created -->
        <td>
          <td-value type="dateTimeWithSpace" [value]="item?.created"></td-value>
        </td>

        <!-- expireDate -->
        <td>
          <td-value
            type="dateTimeWithSpace"
            [value]="item?.expireDate"
          ></td-value>
        </td>

        <!------------------------------- operations -------------------------------->
        <td class="sticky-td">
          <!-- open menu btn -->
          <div
            app-menu-btn
            [matMenuTriggerFor]="menu"
            [isShowDotsMenu]="true"
          ></div>

          <!-- menu -->
          <mat-menu #menu="matMenu" xPosition="before">
            <!-- login button -->
            <div
              app-menu-btn
              *ngIf="
                (!isLoginByIdentity ||
                  permissionService.userState()?.isSuperAdmin) &&
                item.id != permissionService.userState()?.organizationId
              "
              icon="mdi mdi-login-variant mdi-20px"
              color="gray"
              [title]="'common.login'"
              (click)="onLoginToOrganization(item?.adminUserId)"
            ></div>

            <!-- edit button -->
            <div app-menu-btn icon="edit" (click)="onUpdate(item?.id)"></div>

            <!-- authentication button -->
            <!-- && permissionService.userState()?.isAdmin -->
            <div
              app-menu-btn
              *ngIf="
                !item.isRealPerson &&
                item.id == permissionService.userState()?.organizationId
              "
              icon="mdi mdi-folder-plus-outline mdi-20px"
              color="indigo"
              [title]="'common.authenticated'"
              (click)="onAddAuthorization(item?.id)"
            ></div>

            <!-- organization documentation button -->
            <div
              app-menu-btn
              icon="mdi mdi-folder-account-outline mdi-20px"
              color="indigo"
              [title]="'common.documentation'"
              (click)="
                onShowDocumentations(
                  item?.id,
                  item.isRealPerson,
                  item.adminUserIdInt
                )
              "
            ></div>

            <!-- Increase User Credit -->
            <!-- (permissionService.userState()?.isSuperAdmin || permissionService.userState()?.isAdmin)  && -->
            <div
              app-menu-btn
              *ngIf="item.id != permissionService.userState()?.organizationId"
              icon="mdi mdi-credit-card-outline mdi-20px"
              color="green"
              [title]="'common.creditTransfer'"
              (click)="onCreditTransfer(item?.id)"
            ></div>

            <!-- group price detail button -->
            <div
              app-menu-btn
              icon="mdi mdi-tag-outline mdi-20px"
              color="blue"
              [title]="'common.groupPriceDetail'"
              (click)="onShowGroupPriceDetail(item?.id, item?.name)"
            ></div>

            <!-- reseller button -->
            <div
              app-menu-btn
              icon="mdi mdi-account-multiple-outline mdi-20px"
              color="gray"
              [title]="'pages.resellers.title'"
              (click)="onShowResellers(item?.id)"
            ></div>

            <!-- organizations black list exceptions button -->
            <div
              app-menu-btn
              *ngIf="permissionService.userState()?.organizationId == 1"
              icon="mdi mdi-cellphone mdi-20px"
              [title]="'common.organizationsBlackListExceptions'"
              color="red"
              (click)="onShowOrganizationsBlackListExceptions(item?.id)"
            ></div>

            <!-- transactions button -->
            <div
              app-menu-btn
              icon="mdi mdi-credit-card mdi-20px"
              color="yellow"
              [title]="'common.transactions'"
              (click)="onShowTransactions(item.id)"
            ></div>

            <!-- delete button -->
            <!-- *ngIf="permissionService.userState()?.isSuperAdmin || permissionService.userState()?.isAdmin" -->
            <div app-menu-btn icon="delete" (click)="onDelete(item)"></div>
          </mat-menu>
        </td>

        <ng-template #justGap>
          <td class="tw-py-20px"></td>
        </ng-template>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!-- add or update form -->
<ng-container *ngIf="pageConfig?.isVisibleForm">
  <app-organizations-form
    [formPageConfig]="formPageConfig"
    (closeFormPage)="getFormResponse($event)"
  >
  </app-organizations-form>
</ng-container>

<!-- organization audit page -->
<ng-container *ngIf="pageConfig?.isVisibleAuditPage">
  <app-audit
    [service]="currentService"
    [methodName]="auditApiMethodName"
    (hidePage)="onHideAuditPage()"
  >
  </app-audit>
</ng-container>

<!-- AuthenticatedMobile audit page -->
<ng-container *ngIf="isShowAuthenticatedMobileAuditPage">
  <app-audit
    [service]="authenticatedMobileService"
    methodName="authenticatedMobileGetAuthenticatedMobilesAudit"
    (hidePage)="onHideAuthenticatedMobileAuditPage()"
  >
  </app-audit>
</ng-container>

<!-- authentication form -->
<ng-container *ngIf="isShowOrganizationAuthentication">
  <app-organizations-authentication-form
    (closeFormPage)="onCloseAuthorization()"
  >
  </app-organizations-authentication-form>
</ng-container>

<!--organization documentation -->
<ng-container *ngIf="isShowOrganizationDocumentation">
  <app-organization-documentation
    [documentationTypes]="DocumentationTypeEnumValues"
    [organizationId]="selectedOrganizationId"
    (closeFormPage)="getFormResponse($event); onCloseDocumentation()"
  >
  </app-organization-documentation>
</ng-container>

<!--user documentation -->
<ng-container *ngIf="isShowUserDocumentation">
  <app-user-documentation-form
    [documentationTypes]="UserDocumentsTypeEnumValues"
    [userId]="adminUserId"
    (closeFormPage)="
      getFormResponse($event);
      isShowUserDocumentation = false;
      showParent = true;
      getParentQueryString()
    "
  >
  </app-user-documentation-form>
</ng-container>

<!-- organization transactions -->
<ng-container *ngIf="isShowOrganizationTransaction">
  <app-organization-transactions-form
    [formPageConfig]="organizationTransactionFormPageConfig"
    [inputOrganizationId]="selectedOrganizationId"
    [currentOrganization]="permissionService.userState()?.organizationId"
    (closeFormPage)="onHideOrganizationTransaction()"
  >
  </app-organization-transactions-form>
</ng-container>

<!-- organization resellers  -->
<ng-container *ngIf="isShowOrganizationResellers">
  <app-organizations-resellers
    [modelWithPagination$]="organizationResellersWithPagination$"
    [organizationId]="selectedOrganizationId"
    (onBack)="onHideResellers()"
  >
  </app-organizations-resellers>
</ng-container>

<!-- organization resellers  -->
<ng-container *ngIf="isShowOrganizationBlackListExceptions">
  <app-organizations-black-list-exceptions
    [organizationId]="selectedOrganizationId"
    (onBack)="onHideOrganizationsBlackListExceptions()"
  >
  </app-organizations-black-list-exceptions>
</ng-container>

<!-- organization Group Price Detail  -->
<ng-container *ngIf="isShowOrganizationGroupPriceDetail">
  <app-organization-group-price-detail
    [groupPriceDetail]="organizationGroupPriceDetail"
    [organizationId]="selectedOrganizationId"
    [organizationName]="selectedOrganizationName"
    (closePage)="
      isShowOrganizationGroupPriceDetail = false;
      showParent = true;
      getParentQueryString()
    "
  >
  </app-organization-group-price-detail>
</ng-container>

<!-- organization transactions  -->
<ng-container *ngIf="isShowOrganizationTransactions">
  <app-organization-transactions
    [organizationTransactionType]="'organizationTransactionByOrganizationId'"
    [organizationId]="selectedOrganizationId"
    (onBack)="onHideTransactions()"
  >
  </app-organization-transactions>
</ng-container>

<!---------------------------------------- help ---------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="pageName"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
